
<style scoped>

body {
    background: white !important;
}
.container-fluid {
    background: white;
}
.btn:focus {
    outline: 0;
    box-shadow: none;
}
.btn.btn-ap {
    border-radius: 50px 0px 0px 50px !important;
    padding: 10px;
    padding-left: 60px;
    padding-right: 60px;
    background-color: #E5E5E5;
    color: black;
    outline: none;
    font-weight: bold;
}
.btn.btn-kap {
    border-radius: 0px 50px 50px 0px !important;
    padding: 10px;
    padding-left: 60px;
    padding-right: 60px;
    background-color: #E5E5E5;
    color: black;
    outline: none;
    font-weight: bold;
}
.router-link-exact-active.active .btn {
    background-color: #0c2c77;
    color: #ffb406;
    font-weight: bold;
}
</style>
<template>
<CContainer fluid>
         
     <CRow class="justify-content-center mb-5">
        <div class="btn-group" role="group" aria-label="Basic example">
            <router-link to="/pages/data-anggota/akuntan-publik">
                <button type="button" class="btn btn-ap" @click.native="tabchange('AKUNTAN PUBLIK')">AKUNTAN PUBLIK</button>
            </router-link>

            <router-link to="/pages/data-anggota/kantor-akuntan-publik">
                <button type="button" class="btn btn-kap" @click.native="tabchange('KANTOR AKUNTAN PUBLIK')">KANTOR AKUNTAN PUBLIK</button>
            </router-link>
        </div>
     </CRow>
    <router-view></router-view>
</CContainer>
</template>

<script>
export default {
    data() {
        return {
            title_tab : 'AKUNTAN PUBLIK',
        }
    },

    mounted() {
        this.mountedchange(this.$router.currentRoute.path)
    },

    mountedchange(value) {
      switch (value) {
          case '/pages/data-anggota/ap':
              this.title_tab = 'AKUNTAN PUBLIK';
              
              break;
          case '/pages/data-anggota/kap':
              this.title_tab = 'KANTOR AKUNTAN PUBLIK';
              break;
          default:
              break;
      }
    }
}
</script>